import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'packages/theming';
import { defineMessages, useIntl } from 'react-intl';
import { Box, Text, constants } from '@match/react-component-library';
import { FAQ_CONSTANTS } from 'modules/constants';
import { useCategories, useSiteData } from 'modules/hooks';

const { CONTACT_US_ID } = FAQ_CONSTANTS;

const { SEMANTIC_COLOR_NAME, SPACE } = constants;

const MobiNavPage: React.FunctionComponent<{}> = () => {
  const intl = useIntl();
  const { categories } = useCategories();
  const { siteDataLoaded } = useSiteData();

  const mobiNavItems = React.useMemo(() => {
    return [
      {
        id: 0,
        name: intl.formatMessage(messages.mostPopular),
      },
      ...categories,
    ];
  }, [categories, intl.formatMessage]);

  if (!siteDataLoaded) {
    return <Box width={300} />;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {mobiNavItems.map(({ id, name }) => (
        <StyledLink exact to={`/${id}`} key={id}>
          <Box center padding={SPACE.LARGE} height={68}>
            <Text color={SEMANTIC_COLOR_NAME.LIGHT} bold>
              {name}
            </Text>
          </Box>
        </StyledLink>
      ))}
      <StyledLink exact to={`/${CONTACT_US_ID}`}>
        <Box center padding={SPACE.LARGE} height={68} textAlign="center">
          <Text color={SEMANTIC_COLOR_NAME.LIGHT} bold>
            {intl.formatMessage(messages.contactUs)}
          </Text>
        </Box>
      </StyledLink>
    </Box>
  );
};

export default MobiNavPage;

const StyledLink = styled(NavLink)(({ theme }) => {
  const { palette, space } = theme;
  return {
    background: palette.core1_50,
    height: '68px',
    width: '300px',
    marginBottom: space.medium,
    '&:hover': {
      textDecoration: 'none',
    },
  };
});

const messages = defineMessages({
  mostPopular: {
    id: 'src/modules/pages/MobiNavPage/MobiNavPage:mostPopular',
    description: 'most popular category text',
    defaultMessage: 'Most Popular',
  },
  contactUs: {
    id: 'src/modules/pages/MobiNavPage/MobiNavPage:contactUs',
    description: 'contact us category text',
    defaultMessage: 'Contact Us',
  },
});
